var React = require('react');

function IcPlaceholderGeofence (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#F4F7F9","d":"M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50z","key":0}),React.createElement("path",{"fill":"#DDE5ED","d":"M50.205 21.935c-14.323 0-23.226 15.484-16.065 27.871l16.065 27.871 16.064-27.87c7.162-12.388-1.741-27.872-16.064-27.872zm0 27.871c-5.871 0-10.645-4.774-10.645-10.645 0-5.87 4.774-10.645 10.645-10.645 5.871 0 10.645 4.774 10.645 10.645 0 5.871-4.774 10.645-10.645 10.645z","key":1})]));
}

IcPlaceholderGeofence.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100"};

module.exports = IcPlaceholderGeofence;

IcPlaceholderGeofence.default = IcPlaceholderGeofence;
